<template lang="html">
    <div class="d-flex justify-content-center align-items-start align-content-start cardContainer position-relative pe-none"
        :class="fit ? 'fit' : (static ? 'static' : '')">
        <template v-if="viewIndex != ''">
            <div class="placeholderer" v-if="load"></div>
            <div class="spaceDinamic1 align-items-center align-content-center  text-start font-1-1 lh-1"
                :style="{ color: images[viewIndex].color1 }"><template v-if="formFields.step1.receiverName == ''">Hola Fam.
                    Hernandez</template><template v-else>Hola {{ capitalizeWords(formFields.step1.receiverName) }}</template>
            </div>
            <div class="spaceDinamic2 d-inline-flex align-items-center text-start font-1-1 lh-1"
                :style="{ color: images[viewIndex].color1 }">Has recibido una Gift Card</div>
            <div class="spaceDinamic3 d-inline-flex align-items-center align-content-center justify-content-center text-start fw-bold font-2-1 lh-1"
                :style="{ color: images[viewIndex].color2, background: images[viewIndex].bg1 }">GIFT CARD
                ${{ formFields.step1.amount.value }}</div>
            <div class="spaceDinamic4"
                :style="{ background: images[viewIndex].bg2, border: '1px solid ' + images[viewIndex].border1 }">
                <img :src="example">
            </div>
            <img :src="images[viewIndex].image" @load="charge($event)" @error="errorImage($event)" class="resizeHeight">
        </template>
    </div>
    <div class="w-100 d-flex justify-content-center align-content-start align-items-start mt-4"
        v-if="viewSelector && !fit && !static">
        <div v-for="(val, key, index) in images" class="circleButton mx-1 mx-md-2" role="button" :key="index"
            @click="setViewIndex(key)" :class="formFields.step1.designId == key ? 'active' : ''"></div>
    </div>
</template>
<script>
export default {
    name: "designList",
    emits: ['setViewIndex'],
    props: {
        viewSelector: {
            default: true,
            type: Boolean
        },
        formFields: {},
        fit: {
            default: false,
            type: Boolean
        },
        static: {
            default: false,
            type: Boolean
        },
    },
    mounted() {
        if (this.formFields.step1.designId == '') {
            let defaultIndex = Object.keys(this.images)[0];
            this.setViewIndex(defaultIndex);
        } else {
            this.setViewIndex(this.formFields.step1.designId);
        }
    },
    data() {
        return {
            load: true,
            viewIndex: '',
            example: require('@/assets/images/example.png'),
            images: {
                /*'bpt-1': {
                    image: require('@/assets/images/franchise/bpt/navidad.png'),
                    color1: '#003A86',
                    color2: '#FFF',
                    bg1: "#003A86",
                    bg2: "#FFF",
                    border1: "#f0f0f0"
                },*/
                'bpt-2': {
                    image: require('@/assets/images/franchise/bpt/cumple.png'),
                    color1: '#FFF',
                    color2: '#D10631',
                    bg1: "#FFF",
                    bg2: "#FFF",
                    border1: "transparent"
                },
                'bpt-3': {
                    image: require('@/assets/images/franchise/bpt/generica.png'),
                    color1: '#FFF',
                    color2: '#D10631',
                    bg1: "#FFF",
                    bg2: "#FFF",
                    border1: "transparent"
                },
                'bpt-4': {
                    image: require('@/assets/images/franchise/bpt/incentivo.png'),
                    color1: '#FFF',
                    color2: '#D10631',
                    bg1: "#FFF",
                    bg2: "#FFF",
                    border1: "transparent"
                }
            }
        }
    },
    methods: {
        charge(e) {
            setTimeout(() => {
                this.load = false;
            }, 300)
        },
        errorImage(e) {
            this.load = false;
        },
        setViewIndex(index) {
            if(index == this.viewIndex){
                return false
            }
            this.load = true;
            this.viewIndex = index;
            this.$emit('setViewIndex', index);
        }
    }
}
</script>
<style lang="css" scoped>
.placeholderer {
    width: 100%;
    height: 100%;
    left: 0;
    top: 0;
    background: linear-gradient(to right, #eee 5%, #fefefe 25%, #eee 33%);
    background-size: 800px 104px;
    z-index: 20;
    animation: placeholderer 1s infinite;
    position: absolute;
    z-index: 10;
}

.cardContainer {
    border-radius: 18px;
    border: 2px solid var(--quartenary);
    background-color: var(--quartenary);
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
}

.resizeHeight {
    width: 100%;
    height: 100%;
    object-fit: fit;
    border-radius: 4px;
}

.spaceDinamic1 {
    position: absolute;
    left: 20%;
    top: 23%;
    height: 19%;
    width: 60%;
    font-size: 150%;
    word-break: break-word;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: '-';
}

.spaceDinamic2 {
    position: absolute;
    left: 20%;
    top: 41.5%;
    height: 10%;
    width: 60%;
}

.spaceDinamic3 {
    position: absolute;
    left: 16%;
    top: 52%;
    height: 7%;
    width: 68%;
    background-color: #fff;
}

.spaceDinamic4 {
    position: absolute;
    display: flex;
    align-items: center;
    justify-content: center;
    align-content: center;
    left: 32%;
    top: 62%;
    height: 20%;
    width: 36%;
    border-radius: 12px;
}

.cardContainer.fit {
    width: 100% !important;
    height: auto !important;
}

.cardContainer.static {
    width: 100% !important;
    height: 100% !important;
    border-radius: 5px !important;
    border: 1px solid var(--quartenary);
    background-color: var(--quartenary);
    overflow: hidden;
    pointer-events: none;
    user-select: none;
    -webkit-user-select: none;
    -moz-user-select: none;
}


.static .spaceDinamic1 {
    font-size: 5.2px !important;
    top: 22.8% !important;
}

.static .spaceDinamic2 {
    top: 41% !important;
    font-size: 3px !important;
}

.static .spaceDinamic3 {
    line-height: 8px;
    left: 13%;
    width: 74%;
    font-size: 3.5px !important;
}

.static .spaceDinamic4 {
    left: 32%;
    top: 62.5%;
    height: 16%;
    width: 32%;
    border-radius: 4px;
}

@media (min-width: 0px) {
    .cardContainer {
        width: 200px;
        height: 355px;
    }

    .spaceDinamic1 {
        font-size: 130%;
        top: 23%;
    }

    .spaceDinamic2 {
        font-size: 70%;
    }

    .spaceDinamic3 {
        font-size: 85%;
    }

    .fit .spaceDinamic1 {
        font-size: 80% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 50% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 50% !important;
    }

}

@media (min-width: 576px) {
    .cardContainer {
        width: 250px;
        height: 444px;
    }

    .spaceDinamic1 {
        font-size: 170%;
        top: 23%;
    }

    .spaceDinamic2 {
        font-size: 90%;
    }

    .spaceDinamic3 {
        font-size: 115%;
    }

    .fit .spaceDinamic1 {
        font-size: 160% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 80% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 100% !important;
    }


}

@media (min-width: 768px) {
    .cardContainer {
        width: 355px;
        height: 631px;
    }

    .spaceDinamic1 {
        font-size: 240%;
        top: 23%;
    }

    .spaceDinamic2 {
        font-size: 150%;
    }

    .spaceDinamic3 {
        font-size: 165%;
    }

    .fit .spaceDinamic1 {
        font-size: 160% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 80% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 100% !important;
    }
}

@media (min-width: 992px) {
    .cardContainer {
        width: 355px;
        height: 631px;
    }

    .spaceDinamic1 {
        font-size: 240%;
        top: 23%;
    }

    .spaceDinamic2 {
        font-size: 150%;
    }

    .spaceDinamic3 {
        font-size: 165%;
    }

    .fit .spaceDinamic1 {
        font-size: 165% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 80% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 105% !important;
    }
}

@media (min-width: 1200px) {
    .cardContainer {
        width: 200px;
        height: 355px;
    }

    .spaceDinamic1 {
        font-size: 140%;
        top: 23% !important;
    }

    .spaceDinamic2 {
        font-size: 70%;
    }

    .spaceDinamic3 {
        font-size: 85%;
    }

    .fit .spaceDinamic1 {
        font-size: 70% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 35% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 48% !important;
    }
}

@media (min-width: 1400px) {
    .cardContainer {
        width: 280px;
        height: 498px;
    }

    .spaceDinamic1 {
        font-size: 190%;
        top: 23%;
    }

    .spaceDinamic2 {
        font-size: 110%;
    }

    .spaceDinamic3 {
        font-size: 125%;
    }

    .fit .spaceDinamic1 {
        font-size: 130% !important;
    }

    .fit .spaceDinamic2 {
        font-size: 60% !important;
    }

    .fit .spaceDinamic3 {
        font-size: 75% !important;
    }
}





.spaceDinamic4 img {
    height: 80%;
    max-width: 80%;
    object-fit: contain;
}

.float1 {
    position: absolute;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    height: 7%;
    left: 18%;
    top: 50%;
    padding-top: 7%;
    width: 64%;
    line-height: 0;
}

.circleButton {
    border-radius: 50%;
    height: 30px;
    width: 30px;
    border: 3px solid var(--quartenary);
    background-color: var(--tertiary);
}

.circleButton.active {
    border-color: var(--secondary);
}

.circleButton:hover {
    background-color: var(--secondary);
}

@media (min-width: 1199px) {
    .circleButton {
        height: 20px;
        width: 20px;
    }
}
</style>